module.exports = __webpack_public_path__ + "e48c1e3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/products/atoms.svg
// module id = 764
// module chunks = 2